import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import * as R from 'ramda'
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch, useAppSelector } from '../../../../../../hooks/hooks';
import { deepCopy } from '../../../../../../common/services/common.service';
import { categories } from '../../../../../../redux/categories/action';
import { selectCategoriesListItems } from '../../../../../../redux/categories/selector';
import { selectCurrent } from '../../../../../../redux/settings/selectors';
import { tags } from '../../../../../../redux/tags/action';
import { selectTagsListItems } from '../../../../../../redux/tags/selector';
import { settings } from '../../../../../../redux/settings/actions';
import UploadFiles from '../../../../../../models/UploadFile';
import PageLoader from '../../../../../../components/PageLoader';
import { selectListItems } from '../../../../../../redux/library/selector';
import { selectCustomersListItems } from '../../../../../../redux/customers/selector';
import { customers } from '../../../../../../redux/customers/action';
import { vendors } from '../../../../../../redux/vendors/action';
import { selectVendorsListItems } from '../../../../../../redux/vendors/selector';
import ServiceabilityComponent from '../components/serviceability.component';
import { selectServiceabilityQueryItems } from '../../../../../../redux/serviceabilities/selector';
import { selectPinCodesListItems } from '../../../../../../redux/pin-codes/selector';
import { serviceabilities } from '../../../../../../redux/serviceabilities/action';
import { pinCodes } from '../../../../../../redux/pin-codes/action';
import { selectAccountsListItems } from '../../../../../../redux/accounts/selector';
import { selectAccountTypesListItems } from '../../../../../../redux/account-types/selector';
import { accountTypes } from '../../../../../../redux/account-types/action';
import { accounts } from '../../../../../../redux/accounts/action';
import { ListCriteria } from '../../../../types/list-criteria';


let currentChange: any = {}
const Serviceability = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const { getUploadFiles } = useAppSelector(selectCurrent)
  const libraryData = useSelector(selectListItems)
  const tagsLists = useSelector(selectTagsListItems)
  const categoriesLists = useSelector(selectCategoriesListItems)
  const vendorsLists = useSelector(selectVendorsListItems)
  const customerLists = useSelector(selectCustomersListItems)
  const queryItems = useSelector(selectServiceabilityQueryItems)
  const pinCodesLists = useSelector(selectPinCodesListItems)
  const [selectedServiceabilityValues, setSelectedServiceabilityValues] = useState([]);
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [accountTypesList, setAccountTypesList] = useState<any>([]);
  const [associatedAccountTypeId, setAssociatedAccountTypeId] = useState<number | undefined>();
  const [ownerLevelId, setOwnerLevelId] = useState<number | undefined>();
  const accountItems = useSelector(selectAccountsListItems)
  const accountTypeItems = useSelector(selectAccountTypesListItems)
  const [accountsList, setAccountsList] = useState<any>([])

  const TypeData = libraryData?.result?.Type
  const [
    selectedServiceabilitys,
    setSelectedServiceabilitys
  ] = useState<any>([])
  const [
    categoryImageIndex,
    setServiceabilityImageIndex
  ] = useState<any>([])
  const [
    mediaFiles,
    setMediaFiles
  ] = useState<any>([])
  const [
    openFile,
    setOpenFile
  ] = useState<any>([]);


  const listAccountTypes = async () => {
    await dispatch(accountTypes.resetAction({ actionType: 'list' }))
    await dispatch(accountTypes.list({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/rms/account-types/list`,
      entity: 'accountTypes',
      jsonData: {}
    }))
  }

  const listDBAAccountTypes = async () => {
    // v6.1/organization/dbn/dba-type-dba-mappings
    await dispatch(accountTypes.resetAction({ actionType: 'list' }))
    await dispatch(accountTypes.list({
      url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/dba-types/list`,
      entity: 'accountTypes',
      jsonData: {}
    }))
  }

  const listDBNBizAccountTypes = async () => {
    // v6.1/organization/dbn/biz-net-types
    await dispatch(accountTypes.resetAction({ actionType: 'list' }))
    await dispatch(accountTypes.list({
      url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/biz-net-types/list`,
      entity: 'accountTypes',
      jsonData: {}
    }))
  }

  const listAccountsByType = async ({ searchCriteria, filterCriteria, dateCriteria }: ListCriteria) => {
    await dispatch(accounts.resetAction({ actionType: 'list' }))
    await dispatch(accounts.list({
      url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/organization/rms/accounts/list`,
      entity: 'accounts',
      jsonData: {
        "Filters": filterCriteria,
        "Searches": searchCriteria,
        "DateCriteria": dateCriteria,
      }
    }))
  }


  useEffect(() => {
    setAssociatedAccountTypeId(selectedServiceabilitys?.OwnerTypeId);
    setOwnerLevelId(selectedServiceabilitys?.OwnerLevelId);
  }, [selectedServiceabilitys]);

  useEffect(() => {
    if (associatedAccountTypeId && accountTypesList) {
      const accountTypeName = accountTypesList?.find(
        (item: any) => item.Id === associatedAccountTypeId
      )?.Name;
      const accountTypeValue = TypeData.find(
        (type: any) => type.Text === accountTypeName
      )?.Text;
      if (accountTypeValue) {
        listAccountsByType({
          filterCriteria: [{
            "FieldName": "Type",
            "FilterOperatorId": 6,
            "FieldValue": accountTypeValue,
            "FieldType": "text"
          }]
        })
      }
    }
  }, [accountTypesList, associatedAccountTypeId]);

  useEffect(() => {
    switch (ownerLevelId) {
      case 10:
        listAccountTypes();
        break;
      case 11:
        listDBAAccountTypes();
        break;
      case 12:
        listDBNBizAccountTypes();
        break;
      default:
        dispatch(accountTypes.resetAction({ actionType: 'list' }))
        break;

    }
  }, [ownerLevelId]);

  useEffect(() => {
    switch (ownerLevelId) {
      case 10:
        setAccountTypesList(accountTypeItems?.result?.items);
        setAccountsList([]);
        break;
      case 11:
        setAccountTypesList(accountTypeItems?.result?.items?.map(o => { return { Id: o?.Id, Name: o?.Name } }));
        setAccountsList([]);
        break;
      case 12:
        setAccountTypesList(accountTypeItems?.result?.items?.map(o => { return { Id: o?.IEAccountTypeId, Name: o?.IEAccountTypeName } }));
        setAccountsList([]);
        break;
      default:
        setAccountTypesList([]);
        setAccountsList([]);
        break;
    }
  }, [accountTypeItems]);

  useEffect(() => {
    dispatch(accounts.resetAction({ actionType: 'list' }))
    setAccountsList([])
  }, []);

  useEffect(() => {
    setAccountsList(accountItems?.result?.items || [])
  }, [accountItems]);


  const fetchQueryById = () => {
    dispatch(serviceabilities.query({
      url: `https://policy.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/policy/shipment/serviceabilities/fetch-detail`, entity: 'serviceabilities', jsonData: {

        
    "Records": [
        {
            "Id": parmas?.id
        }
    ]
}
     
      
    })).then(() => {
      setIsQuery(true)
    }).then(() => {
      setIsLoading(false)
    })


  }

  const handleInnerbasicFormChange: any = (event: any, field: string) => {
    setSelectedServiceabilitys({ ...selectedServiceabilitys, [field]: event })
  }
  const handleInnerFormChange: any = ({ value, field, data }: any) => {
    currentChange = { value, field, data, idx: 0 }
    const fields = R.split(
      '.',
      field
    );
    const valueData = { ...data, [fields[1]]: value }// inner data update
    setSelectedServiceabilitys({ ...selectedServiceabilitys, [fields[0]]: valueData });
  }
  const handleFormMediaItemChange: any = ({ value, field, idx }: any) => {
    const items = deepCopy(mediaFiles);// deep copy of grn items
    let item = items[idx];// deep copy of item to be edited
    item = { ...item, [field]: value }// updated the particular item
    items[idx] = item;
    currentChange = { value, field, idx }
    setMediaFiles(items);
  }

  useEffect(
    () => {
      dispatch(accountTypes.list({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/rms/account-types/list`,
        entity: 'accountTypes',
        jsonData: {}
      }))
        .then(() => {
          dispatch(tags.list({
            url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v3.0/tag/tag-name/query-by-tag-name-list-value`,
            entity: 'tags',
            jsonData: {}

          }))
        }).then(() => {
          dispatch(categories.list({
            url: `https://catalog.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/catalog/categories/list`,
            entity: 'categories',
            jsonData: {}
          }))
        })
        .then(() => {
          dispatch(vendors.list({ url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/market-place/vendors/list`, entity: 'vendors', jsonData: {} }))
        }).then(() => {
          dispatch(customers.list({
            url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/sales/crm/logistics-customers/list`,
            entity: 'customers',
            jsonData: {}
          }));
        }).then(() => {
          dispatch(pinCodes.list({
            url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/policy/shipment/pin-codes/list`,
            entity: 'pincodes',
            jsonData: {}
          }))
        }).then(() => {
          if (parmas?.id > 0) {
            fetchQueryById()

          } else {
            const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: mediaFiles });
            setMediaFiles(localSelectedMedia)
            const localSelectedDsiscounts = addNewServiceabilityValuesRow({ selectedServiceabilityValuesArg: selectedServiceabilityValues });
            setSelectedServiceabilityValues(localSelectedDsiscounts)
            setIsLoading(false)
          }
        })
    },
    []
  )
  useEffect(
    () => {

      if (isQuery) {
        setSelectedServiceabilitys(queryItems?.result?.items)
        const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: queryItems?.result?.items?.MediaMappings?.MediaFiles });
        setMediaFiles(localSelectedMedia)
        const serviceItemsData: any = queryItems?.result?.items?.Serviceability.map((item: any) => {
          const itemData = {
            Id: item?.Id,
            EntityId: item?.EntityId,
            Name: item?.Name,
            EntityTypeId: item?.EntityTypeId,
            CategoryId: item?.CategoryId,
            unit: item?.Circle?.radius?.unit,
            value: item?.Circle?.radius?.value,
            IsDeliveryHubEnabled: item?.IsDeliveryHubEnabled,
            ShippingTypeId: item?.ShippingTypeId
          }
          return itemData
        })
        const localSelectedDsiscounts = addNewServiceabilityValuesRow({ selectedServiceabilityValuesArg: serviceItemsData });
        setSelectedServiceabilityValues(localSelectedDsiscounts)
        selectedServiceabilitys.PINCode = queryItems?.result?.items?.Serviceability[0]?.PINCode?.PinCode
      }
    },
    [isQuery]
  )

  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    mediaFiles.splice(
      mediaFiles.length - 1,
      1
    )
    selectedServiceabilityValues.splice(selectedServiceabilityValues.length - 1, 1);
    const serviceItemsData: any = selectedServiceabilityValues.map((item: any) => {
      const itemData = {
         Id: item.Id,
        EntityTypeId: item?.EntityTypeId,
        EntityId: selectedServiceabilitys?.ServiceabilityTypeId,
        ShippingTypeId: item?.ShippingTypeId,
        IsDeliveryHubEnabled: item?.IsDeliveryHubEnabled,
        Name: item?.Name,
        CategoryId: item?.CategoryId,
        PINCode: { PinCode: selectedServiceabilitys.PINCode },
        Circle: {
          gps: '',
          radius: {
            unit: item?.unit,
            value: item?.value
          }
        }

      }
      return itemData
    })
    const serviceabilityData = {
      "id":parmas?.id,
      "IsActive": selectedServiceabilitys?.IsActive,
      "Name": selectedServiceabilitys?.Name,
      "OwnerLevelId": selectedServiceabilitys?.OwnerLevelId,
      "OwnerTypeId": selectedServiceabilitys?.OwnerTypeId,
      "OwnerAccountId": selectedServiceabilitys?.OwnerAccountId,
      "ServiceabilityTypeId": selectedServiceabilitys?.ServiceabilityTypeId,
      "Description": selectedServiceabilitys?.Description,
      "StartDateUtc": selectedServiceabilitys?.StartDateUtc,
      "EndDateUtc": selectedServiceabilitys?.EndDateUtc,
      "Remarks": selectedServiceabilitys?.Remarks,
      "Inclusions": selectedServiceabilitys?.Inclusions,
      "Exclusions": selectedServiceabilitys?.Exclusions,
      "MediaMappings": {
        "MediaFiles": mediaFiles,
        "Templates": [

        ]
      },
      "Serviceability": serviceItemsData
    }
    if (parmas?.id > 0) {
      await dispatch(serviceabilities.resetAction({ actionType: 'update' }))
      await dispatch(serviceabilities.update({
        url: `https://policy.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/policy/shipment/serviceabilities`, entity: 'serviceabilities', jsonData: {

          Records: [
            serviceabilityData  
          ]

        }
      })).then(() => {
        back()
      })

    } else {

      await dispatch(serviceabilities.resetAction({ actionType: 'create' }))
      await dispatch(serviceabilities.create({
        url: `https://policy.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/policy/shipment/serviceabilities`, entity: 'serviceabilities', jsonData: {

          Records: [
            serviceabilityData
          ]

        }
      })).then(() => {
        back()
      })
    }

  }

  const back = () => {
    navigate('/management/policy/shipment/serviceabilities')
  }
  const addNewMediaFilesRow = ({ selectedMediaFilesArg }: any) => {
    const localSelectedmedia = deepCopy(selectedMediaFilesArg)
    const newsSelectedMedia = {
      Id: 0,
      FileTypeId: 0,
      OwnerTypeId: 163,
      FileMappingURL: ''
    }
    if (localSelectedmedia.length === 0 ||
      localSelectedmedia[localSelectedmedia?.length - 1]?.FileTypeId !== 0
    ) {
      localSelectedmedia?.push(newsSelectedMedia)
    }

    return localSelectedmedia
  }
  const setMediaInfo = async () => {
    let localSelectedMedia = deepCopy(mediaFiles)
    localSelectedMedia.splice(
      currentChange.idx,
      1,
      { ...localSelectedMedia[currentChange.idx] }
    );
    localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: localSelectedMedia });
    currentChange.field = 'FileTypeIdDONE'
    setMediaFiles(localSelectedMedia)
  }
  const changeImage = (idx: number, templateField: any, fileType: any) => {
    setServiceabilityImageIndex(idx)
    dispatch(settings.set({ getUploadFiles: 'open' }))
    setOpenFile({
      currentFileSrc: mediaFiles[idx][templateField],
      folder: 'serviceabilities',
      type: fileType
    })
  }
  const handleSubmit = (data: any) => {

    mediaFiles[categoryImageIndex].FileMappingURL = data
    const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: mediaFiles });
    setMediaFiles(localSelectedMedia)
  }
  const addNewServiceabilityValuesRow = ({ selectedServiceabilityValuesArg }: any) => {
    const localSelectedServiceabilityValues = deepCopy(selectedServiceabilityValuesArg);
    const newServiceabilityValue = {
      Id: 0,
      ShippingTypeId: 0,
      EntityId: selectedServiceabilitys?.ServiceabilityTypeId,
      EntityTypeId: 163,
      ShippingTypePreferenceId: 0,
      Name: '',
      PinCode: selectedServiceabilitys?.PinCode,
      CategoryId: 0,
      Circle: {
        radius: {}
      }
    };
    if (
      localSelectedServiceabilityValues.length === 0 ||
      localSelectedServiceabilityValues[localSelectedServiceabilityValues?.length - 1]
        ?.Name !== ''
    ) {
      localSelectedServiceabilityValues?.push(newServiceabilityValue);
    }

    return localSelectedServiceabilityValues;
  };
  const handleFormServiceabilityItemChange: any = ({ value, field, idx }: any) => {
    const items = deepCopy(selectedServiceabilityValues); // deep copy of items
    let item = items[idx]; // deep copy of item to be edited
    item = { ...item, [field]: value }; // updated the particular item
    items[idx] = item;
    currentChange = { value, field, idx };
    setSelectedServiceabilityValues(items);
  };
  const setServiceabilityValuesInfo = async () => {
    let localServiceabilityValues = deepCopy(selectedServiceabilityValues);
    localServiceabilityValues.splice(currentChange.idx, 1, {
      ...localServiceabilityValues[currentChange.idx],
    });
    localServiceabilityValues = addNewServiceabilityValuesRow({
      selectedServiceabilityValuesArg: localServiceabilityValues,
    });
    currentChange.field = 'NameDONE';
    setSelectedServiceabilityValues(localServiceabilityValues);
  };
  useEffect(() => {
    if (currentChange.field === 'Name') {
      setServiceabilityValuesInfo();
    }
  }, [selectedServiceabilityValues]);

  const handleClose = () => {
    dispatch(settings.set({ getUploadFiles: 'close' }))

  }

  useEffect(
    () => {
      if (currentChange.field === 'FileTypeId') {
        setMediaInfo()
      }
    },
    [mediaFiles]
  )

  return (
    <>
      {getUploadFiles == 'open' && <UploadFiles currentFilesSrc={openFile?.currentFileSrc}
        folder={openFile?.folder}
        handleClose={handleClose}
        handleFilesSubmit={handleSubmit}
        type={openFile?.type}
        ownerId={parmas?.id}
      />}
      {isLoading ? <PageLoader /> :


        <ServiceabilityComponent
          accountListLoading={accountItems?.isLoading}
          accountsList={accountsList}
          accountTypesListLoading={accountTypeItems?.isLoading}
          accountTypesList={accountTypesList}
          PolicyOwnerType={libraryData?.result?.PolicyOwnerType}
          onInnerBasicFormChange={handleInnerbasicFormChange}
          selectedServiceabilitys={selectedServiceabilitys}
          shippingType={libraryData?.result?.ServiceabilityConstruct}
          fileTypes={libraryData?.result?.FileType}
          categories={categoriesLists?.result?.items}
          vendors={vendorsLists?.result?.items}
          allTags={tagsLists?.result?.items}
          back={back}
          onInnerFormChange={handleInnerFormChange}
          handleFormSubmit={handleFormSubmit}
          handleFormMediaItemChange={handleFormMediaItemChange}
          mediaFiles={mediaFiles}
          changeImage={changeImage}
          id={parmas?.id}
          pinCodes={pinCodesLists?.result?.items}
          customers={customerLists?.result?.items}
          selectedServiceabilityValues={selectedServiceabilityValues}
          handleFormServiceabilityItemChange={handleFormServiceabilityItemChange}
        />
      }

    </>
  )

}

export default Serviceability;